export default __webpack_public_path__ + "static/media/snapptrip-article.f0e4b4a9.png";